export const ActionTypes = {
  FETCH_PLP_API: 'listingV2/fetch_plp_api',
  SET_LISTING_ERROR: 'listingV2/set_listing_error',
  SET_LISTING_DATA: 'listingV2/set_listing_data',
  UPDATE_APPLIED_FILTERS: 'listingV2/update_applied_filters',
  UPDATE_PAGE_NUMBER: 'listingV2/update_page_number',
  UPDATE_CROSS_PLATFORM_REDIRECT_CONFIG: 'listingV2/update_cross_platform_redirect_config',
  SET_STORE_REDIRECT_COUNT: 'listingV2/set_store_redirect_count',
};
